module.exports = __webpack_public_path__ + "img/人群获取关闭.54747645.svg";